var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-link',{attrs:{"to":_vm.$pagePath('index')}},[_c('vs-image',_vm._b({attrs:{"src":"/logo.svg","fit":"contain","position":"left","alt":"No Loss Logo"}},'vs-image',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }